import { render, staticRenderFns } from "./hasElectricNetworkLessThanTenYears.vue?vue&type=template&id=3110152e&scoped=true"
import script from "./hasElectricNetworkLessThanTenYears.vue?vue&type=script&lang=ts"
export * from "./hasElectricNetworkLessThanTenYears.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3110152e",
  null
  
)

export default component.exports